import { IonButton, IonIcon, IonInput, IonItem, IonLabel, IonRow, IonSpinner, IonText, IonTextarea } from "@ionic/react"
import { checkmarkCircle, checkmarkCircleOutline, personSharp } from "ionicons/icons";

import './ActionButton.css'

interface Props {
    text?: string,
    color?: string,
    loading?: boolean,
    disabled?: boolean,
    click?: any,
    href?: string,
    target?: string,
    compact?: boolean,
    class?: string,
    hasBadge?: boolean,
    noMargin?: boolean,
    noSubmit?: boolean
}

const ActionButton: React.FC<Props> = (props) => {
    let className = ["action-button"];
    
    if (props.color) className.push(props.color);
    if (props.compact) className.push("compact");
    if (props.class) className.push(props.class);
    if (props.noMargin) className.push("no-margin");

    return (
        !props.compact ?
            <div className={className.join(" ").toString()}>
                <IonButton type={!props.noSubmit ? "submit" : "button"} href={props.href!} target={props.target} disabled={props.loading} onClick={!props.loading ? props.click : null} expand="block">
                    {!props.loading ? (props.children ? props.children : <IonText>{props.text}</IonText>) : <IonSpinner name={window.layoutMode == "ios" ? "lines" : undefined}></IonSpinner>}
                </IonButton>
                {props.hasBadge ? <IonIcon icon={checkmarkCircleOutline} className="badge-icon" /> : null}
            </div>
            :
            <div className={className.join(" ").toString()}>
                <IonButton type={!props.noSubmit ? "submit" : "button"} href={props.href!} target={props.target} onClick={!props.loading ? props.click : null} disabled={props.loading}>
                    {!props.loading ? (props.children ? props.children : <IonText>{props.text}</IonText>) : <IonSpinner name={window.layoutMode == "ios" ? "lines" : undefined}></IonSpinner>}
                </IonButton>
                {props.hasBadge ? <IonIcon icon={checkmarkCircle} className="badge-icon" /> : null}
            </div>
    )
}

export default ActionButton